import { render, staticRenderFns } from "./RegionPlans.vue?vue&type=template&id=d9e822c0&scoped=true&"
import script from "./RegionPlans.vue?vue&type=script&lang=js&"
export * from "./RegionPlans.vue?vue&type=script&lang=js&"
import style0 from "./RegionPlans.vue?vue&type=style&index=0&id=d9e822c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e822c0",
  null
  
)

export default component.exports